import { Component, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';
@Component({
    selector: 'app-dc-date-input',
    templateUrl: './dc-date-input.component.html',
    styleUrls: ['./dc-date-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DcDateInputComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class DcDateInputComponent extends ControlValueAccessorConnector {
  @Input() id: string;
  @Input() label?: string;
  @Input() readonly: boolean;
  @Input() placeholder?: string;
  @Input() darkMode?: boolean;
  @Input() helpText?: string;
  @Input() container?: 'body' | '';

  constructor(injector: Injector) {
    super(injector);
  }

  canClickDateButton(dateObjRef) {
    dateObjRef.toggle();
  }
}
